import {createRouter, createWebHistory} from "vue-router"
import login from '../pages/login.vue';
import register from '../pages/register.vue';
import profile from '../pages/user/index.vue';

// User
import Body from '../components/body';
import Default from '../pages/dashboard/main.vue';

import reportList from '../pages/dnaReport/application.vue';
import reportSingle from '../pages/dnaReport/single-application.vue';
import reportSubmit from '../pages/dnaReport/submit.vue';

import assessmentHome from '../pages/assessments/assessment.vue';
import interventionHome from '../pages/interventions/intervention.vue';
import moduleHome from '../pages/modules/moduleHome';
import reportHome from '../pages/report_progress/index.vue';

import supportHome from '../pages/support/index.vue';
import supportTicket from "@/pages/support/support_page.vue";
import forumLanding from "@/pages/forum_landing.vue";

import subscriptionHome from "@/pages/subscriptions/index.vue";
import subscriptionSuccess from "@/pages/subscriptions/success.vue";
import FeedbackForm from "@/pages/support/feedbackForm.vue";
import systemFeedbackForm from "@/pages/support/systemFeedbackForm.vue";

import RewardHome from '@/pages/rewards/index.vue'
import activityHome from '@/pages/activity/index.vue'
const routes =[
  {
    path: '/',
    component: Body,
    children: [
      {
        path: '',
        redirect: '/dashboard'
      },
      {
        path: '/dna-report',
        redirect: '/dna-report/application'
      },
      {
        path: '/activities',
        name: 'activities',
        component: activityHome,
        meta:{
          name: 'Activities',
          requireAuth: true
        },
      },
      {
        path: '/rewards',
        name: 'rewards',
        component: RewardHome,
        meta:{
          name: 'Rewards',
          requireAuth: true
        },
      },
      {
        path: '/feedback',
        name: 'feedback',
        component: FeedbackForm,
        meta:{
          name: 'Feedback',
          requireAuth: true
        },
      },
      {
        path: '/system-feedback',
        name: 'system-feedback',
        component: systemFeedbackForm,
        meta:{
          name: 'System Feedback',
          requireAuth: true
        },
      },
      {
        path: '/packages_subscription',
        name: 'subscription',
        component: subscriptionHome,
        meta:{
          name: 'Subcription Plan',
          requireAuth: true
        },
      },
      {
        path: '/payment-history',
        name: 'payment-history',
        component: () => import('@/pages/subscriptions/payment_history.vue'),
        meta:{
          name: 'Payment History',
          requireAuth: true
        },
      },
      {
        path: '/success',
        name: 'subscription_success',
        component: subscriptionSuccess,
        meta:{
          name: 'Payment Success',
          requireAuth: true
        },
      },
      {
        path: '/forum',
        name: 'forum',
        component: forumLanding,
        meta:{
          name: 'Forum',
          requireAuth: true
        },
      },
      {
        path: '/dashboard',
        name: 'dashboard',
        component: Default,
        meta:{
          name: 'Dashboard',
          requireAuth: true
        },
      },
      {
        path: '/dna-report/apply',
        name: 'dna-report-submit',
        component: reportSubmit,
        meta:{
          name: 'Submit Report',
          requireAuth: true
        },
      },
      {
        path: '/dna-report/application',
        name: 'dna-report-application',
        component: reportList,
        meta:{
          name: 'Application',
          requireAuth: true
        },
      },
      {
        path: '/dna-report/application/:id',
        name: 'dna-report-single-application',
        component: reportSingle,
        meta:{
          name: 'Report',
          requireAuth: true
        },
        props: true,
        query: { report_ony: false }
      },
      {
        path: '/child/:child_id/assessment/:id',
        name: 'assessment-home',
        component: assessmentHome,
        meta:{
          name: 'Asessment',
          requireAuth: true
        },
        props: true
      },
      {
        path: '/child/:child_id/intervention/:id',
        name: 'intervention-home',
        component: interventionHome,
        meta:{
          name: 'Intervention',
          requireAuth: true
        },
        props: true
      },
      {
        path: '/child/:child_id/report/:trait_id',
        name: 'report-home',
        component: reportHome,
        meta:{
          name: 'Reports',
          requireAuth: true
        },
        props: true
      },
      {
        path: '/modules/:id',
        name: 'modules-home',
        component: moduleHome,
        meta:{
          name: 'Module',
          requireAuth: true
        }
      },
      {
        path: '/support',
        name: 'support',
        component: supportHome,
        meta:{
          name: 'FAQ',
          requireAuth: true
        }
      },
      {
        path: '/support_ticket',
        name: 'support-ticket',
        component: supportTicket,
        meta:{
          requireAuth: true,
          name: 'Support Ticket'
        }
      },
      {
        path: '/profile',
        name: 'profile',
        component: profile,
        meta:{
          name: 'Profile'
        }
      },
      {
        path: '/:pathMatch(.*)*',
        name: 'not-found',
        component: () => import('../pages/error/NotFound.vue'),
        meta: {
          name: 'Page Not Found',
          requireAuth: true
        }
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: login,
    meta:{
      name: 'Login',
      requireAuth: false
    }
  },
  {
    path: '/register',
    name: 'register',
    component: register,
    meta:{
      name: 'Register'
    }
  },
  {
    path: '/privacy-policy',
    name: 'privacy-policy',
    component: () => import('../pages/policy/privacy.vue'),
    meta:{
      name: 'Privacy Policy'
    }
  }
]
const router = createRouter({
    history: createWebHistory(),
    routes
})

router.beforeEach((to, from, next) => {
  if (to.name !== 'login' && to.meta.requireAuth && localStorage.getItem('uid') === null){
    next({name: 'login'})
  }else{
    if (from.query.layout && !to.query.layout) {
      if (to.path === from.path) {
        // console.log('Identical routes detected')
        return // This is a no-no via the documentation, but a bug in routing to identical routes strips query params, and this prevents that
      }
      document.title = to.meta.name + ' | CareXera'
      next({path: to.path, query: {layout: from.query.layout}})
    }
    document.title = to.meta.name + ' | CareXera'
    next()
  }
});
export default router